import reducer from './reducer'
import * as SaveSearchesOperations from './operations'
import * as SaveSearchesUtils from './utils'
import * as SaveSearchesTypes from './types'
import * as SaveSearchesActions from './actions'

export { SaveSearchesOperations, SaveSearchesUtils, SaveSearchesTypes, SaveSearchesActions }

export default reducer
